import React from 'react';

export default function ResultsBlock5Evolution() {
  return (
    <section className="py-24 md:py-24 px-6 md:px-16 bg-surface border-b border-line">
      <div className="max-w-[1280px] mx-auto">
        
        <div className="max-w-[800px] mx-auto text-center">
          <div className="text-[14px] font-semibold text-brand tracking-widest uppercase mb-6">
            EVOLUCIÓN
          </div>
          <h2 className="text-[32px] md:text-[48px] font-bold text-ink mb-8 tracking-tight">
            De piloto a capacidad instalada.
          </h2>
          
          <div className="flex flex-col items-center justify-center space-y-4 relative w-full mb-16">
            <div className="bg-[rgb(207,249,255)] border border-brand/20 p-8 md:p-12 rounded-xl w-full relative text-center">
              <div className="text-[14px] font-extrabold text-brand tracking-widest uppercase mb-6">BAC (By Yo Me Controlo)</div>
              <h3 className="text-[20px] md:text-[24px] font-medium text-ink leading-[1.6]">
                BAC es la capacidad gestionada de operación poblacional que generaliza estos aprendizajes a prevención, cronicidad y recuperación de continuidad.
              </h3>
            </div>
          </div>

          <div className="bg-surface border-l-4 border-brand border-y border-r border-y-gray-200 border-r-gray-200 p-8 rounded-xl text-left relative max-w-[700px] mx-auto">
            <div className="text-[14px] font-extrabold text-brand tracking-widest uppercase mb-4">EVIDENCIA EXTERNA ADICIONAL — CONTINUIDAD DEL EMPA</div>
            <p className="text-[16px] text-ink leading-[1.6] mb-4">
              La necesidad operacional identificada en nuestros pilotos es consistente con evidencia externa. Investigadores UC y Fundación Ancora UC describieron el EMPA como una cascada diagnóstica. En una cohorte de 36.000 personas, 15% completó el proceso.
            </p>
            <p className="text-[16px] text-ink leading-[1.6] mb-6">
              En un piloto en ocho CESFAM, una intervención de gestión activa triplicó la proporción de personas que completó la cascada.
            </p>
            <div className="text-[12px] text-slate-600 font-medium">
              Fuente: Universidad Católica / Fundación Ancora UC, 2026.
            </div>
          </div>
        </div>
        
      </div>
    </section>
  );
}
